module.exports = __webpack_public_path__ + "static/scale-model-of-harbor-fountains-in-baltimore-maryland-2da13d1ba128034ce4a8c502d7f09824.png";